'use client';

import { TabsSection, EventsSection, SocialStreamSection } from './ContentSections/index';

export default function ContentSections() {
  return (
    <section className="bg-gray-50 py-6 lg:min-h-screen lg:py-8 lg:flex lg:items-center">
      <div className="max-w-7xl mx-auto w-full px-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 lg:h-[80vh]">
          
          {/* Left Section - Press Release/Articles/Photos */}
          <TabsSection />

          {/* Center Section - Upcoming Events */}
          <EventsSection />

          {/* Right Section - Social Stream */}
          <SocialStreamSection />
          
        </div>
      </div>
    </section>
  );
}
